
define('modules/application/wizard/classes/controlledLoads',[
    "app",

    // Libs
    "backbone",

    // Classes
    "./genericCollectionSection"

  ],

  function(app, Backbone, genericCollectionSection) {
    var eventsToBind = _.extend({}, genericCollectionSection.genericCollectionItem.View.prototype.events);
    var genericCollectionItem = _.extend({}, genericCollectionSection.genericCollectionItem, {
      View: genericCollectionSection.genericCollectionItem.View.extend({
        tagName: "li",
        className: "controlledLoad",
        template: "application/wizard/sections/genericCollectionSection/controlledLoads",
        events: _.extend(eventsToBind, {
          "click": "itemClickedEventHandler",
          "change .type": "typeChangedEventHandler",
          "change .accessory": "accessoryChangedEventHandler",
          "keyup input[name='description']": "descriptionChangedEventHandler",
          "click .ui-spinner-right": "incrementButtonClickedEventHandler",
          "click .ui-spinner-left": "decrementButtonClickedEventHandler"
        }),

        serialize: function() {
          return {
            model: this.model,
            app: app
          };
        },

        initialize: function() {
          this.model.bind("render:requested", this.render, this);
          this.model.bind("updateViews", this.render, this);
          this.model.bind("change:number", this.render, this);
        },

        itemClickedEventHandler: function() {
          this.model.set("selected", true);
        },

        incrementButtonClickedEventHandler: function() {
          this.model.incrementPriorityNumber();
        },

        decrementButtonClickedEventHandler: function() {
          this.model.decrementPriorityNumber();
        },

        typeChangedEventHandler: function(e) {
          var typePackageClassId = e.currentTarget.value;

          //Update the model
          this.model.setPackage(typePackageClassId);
        },

        accessoryChangedEventHandler: function(e) {
          if (e.currentTarget.value) {
            var accessoryPackageClassId = e.currentTarget.value;

            //Update the model
            this.model.setAccessory(accessoryPackageClassId);
          }
        },

        descriptionChangedEventHandler: function(e) {
          this.model.set("description", e.currentTarget.value);
        },

        afterRender: function() {
          this.$el.find("select").removeAttr("rel");
          window.customizeFormElements.call();
        }
      }),
      Model: genericCollectionSection.genericCollectionItem.Model.extend({
        defaults: {
          number: -1,
          filterId: -1,
          selected: false,
          description: "",
          priorityValue: 0
        },

        initialize: function() {
          var fetchedPackages = this.get("fetchedPackages"),
            fetchedAccessories = this.get("fetchedAccessories"),
            accessory = this.get("accessory"),
            packageClassId = this.get("packageClassId");

          this.bind("change:selected", this.selectedStatusChangedEventHandler, this);

          this.unbind("change:packageClassId", this.addPackageDetails);
          this.bind("change:packageClassId", this.addPackageDetails, this);

          this.unbind("change:accessory", this.addAccessoryDetails);
          this.bind("change:accessory", this.addAccessoryDetails, this);

          this.bind("product:fetched", this.renderPackage, this);
          this.bind("accessory:fetched", this.renderAccessory, this);

          if (!packageClassId)
            this.setPackage(fetchedPackages[0].packageClassId);
          else
            this.setPackage(packageClassId);
        },

        selectedStatusChangedEventHandler: function() {
          if (this.get("selected"))
            this.get("collectionEventAggregator").trigger("selectedItem:changed", this);
          this.trigger("render:requested");
        },

        setPackage: function(packageClassId) {
          var fetchedAccessories = this.get("fetchedAccessories");
          _.extend(this.attributes, _.filter(this.get("fetchedPackages"), function(iterablePackage) {
            return iterablePackage.packageClassId === packageClassId;
          })[0]);

          var specialVars = this.get("specialVars");

          if (specialVars ? specialVars.gotAccessories : false)
            this.set("accessory", fetchedAccessories[0]);
          else
            this.set("accessory", undefined);

          this.trigger("render:requested");
        },

        incrementPriorityNumber: function() {
          var oldValue = this.get("priorityValue"),
            newValue = oldValue + 1;

          this.set("priorityValue", newValue);
          this.get("collectionEventAggregator").trigger("priorityChanged", {
            number: this.get("number"),
            oldValue: oldValue,
            newValue: newValue
          });
        },

        decrementPriorityNumber: function() {
          var oldValue = this.get("priorityValue"),
            newValue = oldValue - 1;
          if (newValue >= 0) {
            this.set("priorityValue", newValue);
            this.get("collectionEventAggregator").trigger("priorityChanged", {
              number: this.get("number"),
              oldValue: oldValue,
              newValue: newValue
            });
          }
        },

        setAccessory: function(packageClassId) {
          this.set("accessory", _.filter(this.get("fetchedAccessories"), function(iterablePackage) {
            return iterablePackage.packageClassId === packageClassId;
          })[0]);
          this.trigger("render:requested");
        },

        enableChangeMode: function() {
          this.set("changeMode", true);
          this.get("collectionEventAggregator").bind("abilitationToChangeExpansionType:granted", this.completeTypeChange, this);
          this.get("collectionEventAggregator").bind("abilitationToChangeExpansionType:refused", this.revertTypeChange, this);
        },

        disableChangeMode: function() {
          this.set("changeMode", false);
          this.get("collectionEventAggregator").unbind("abilitationToChangeExpansionType:granted", this.completeTypeChange);
          this.get("collectionEventAggregator").unbind("abilitationToChangeExpansionType:refused", this.revertTypeChange);
        },

        completeTypeChange: function(packageAttributes) {
          this.set(packageAttributes);
          this.set("futureBonusVde", undefined);
          this.disableChangeMode();
          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
          this.trigger("render:requested");
        },

        revertTypeChange: function(packageAttributes) {
          this.set("futureBonusVde", undefined);
          this.disableChangeMode();
          alert("Unable to continue");
          this.trigger("render:requested");
        },

        resetValues: function() {
          this.set("catalogId", undefined);
          this.set("description", undefined);
          this.set("image", undefined);
          this.set("links", undefined);
          this.set("mnemonic", undefined);
          this.set("optionalPackages", undefined);
          this.set("packageActuator", undefined);
          this.set("packageClassId", undefined);
          this.set("packageClassLabel", undefined);
          this.set("packageInDepth", undefined);
          this.set("packageLoad", undefined);
          this.set("price", undefined);
          this.set("productCode", undefined);
          this.set("productDescription", undefined);
          this.set("productInDepth", undefined);
          this.set("productLabel", undefined);
          this.set("specialVars", undefined);
          this.set("wizardChoiceDescription", undefined);
          this.set("wizardChoiceLabel", undefined);
          this.set("packageClassDescription", undefined);
          this.set("packageClassId", undefined);
          this.set("packageClassLabel", undefined);
        },

        deliverCurrent: function() {
          var mainProductSpecialVars,
            accessorySpecialVars;

          var sendConsumption = function(consumption) {
            if (consumption) {
              var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

              if (consumption < 0)
                consumptionIndicatorModel.addSupplyCurrent(consumption);
              else
                consumptionIndicatorModel.addCurrentConsumption(consumption);
            }
          };

          if (this.get("specialVars")) {
            if (!(this.get("specialVars") instanceof Object))
              this.attributes.specialVars = JSON.parse(this.attributes.specialVars);

            if ((this.get("specialVars").consumptionGroupId) && (this.get("specialVars").groupExtraConsumption)) {
              var consumptionGroupId = this.get("specialVars").consumptionGroupId.toString();
              var groupExtraConsumption = this.get("specialVars").groupExtraConsumption;
              var maxExtraConsumptions = BticinoS4B.Instances.Models.ApplicationModel.get("maxExtraConsumption");

              if ((!maxExtraConsumptions[consumptionGroupId]) || (maxExtraConsumptions[consumptionGroupId] < groupExtraConsumption))
                maxExtraConsumptions[consumptionGroupId] = groupExtraConsumption;

              BticinoS4B.Instances.Models.ApplicationModel.set("maxExtraConsumption", maxExtraConsumptions);
            }

            if (this.get("specialVars").currentConsumption)
              sendConsumption(this.get("specialVars").currentConsumption);
          }

          if (this.get("accessory") && this.get("accessory").specialVars) {
            if (!(this.get("accessory").specialVars instanceof Object))
              this.attributes.accessory.specialVars = JSON.parse(this.attributes.accessory.specialVars);

            if (this.get("accessory").specialVars.currentConsumption)
              sendConsumption(this.get("accessory").specialVars.currentConsumption);
          }
        }
      })
    });

    var collectionItemModel = genericCollectionItem.Model;
    var collectionModel = Backbone.Collection.extend({
      model: collectionItemModel
    });

    var controlledLoad = _.extend({}, genericCollectionSection, {

      Views: {
        titleBar: genericCollectionSection.Views.titleBar,
        content: genericCollectionSection.Views.content.extend({

          initialize: function() {
            genericCollectionSection.Views.content.prototype.initialize.apply(this);

            //Binding events
            window.BticinoS4B.eventAggregator.unbind("accessoryLine:chosen", this.accessoryLineChosenEventHandler);
            window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen", this.accessoryLineChosenEventHandler, this);

            this.model.unbind("packages:fetched", this.packagesFetchedEventHandler);
            this.model.bind("packages:fetched", this.packagesFetchedEventHandler, this);
            this.model.bind("updateViews", this.render, this);
            this.model.bind("render:requested", this.render, this);

            var accessoryLineId = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");

            if (accessoryLineId)
              this.accessoryLineChosenEventHandler();
          },

          packagesFetchedEventHandler: function() {
            this.$el.find(".loadingSection").hide();
            this.$el.find(".regularSection").show();
            this.render();
          },

          showLoader: function() {
            this.$el.find(".regularSection").hide();
            this.$el.find(".loadingSection").show();
          },

          //Event handlers
          accessoryLineChosenEventHandler: function(accessoryLineId) {
            this.showLoader();
            this.model.fetchPackages();
          },

          addItemButtonClickedEventHandler: function() {
            var collectionItemView = genericCollectionItem.View;
            var elementToAdd = this.model.addItem();
            if (elementToAdd) {
              var viewToAdd = new collectionItemView({
                model: elementToAdd
              });
              //this.insertView(".elements", viewToAdd);
              this.model.sortItems();
              this.$el.find(".alert").remove();
              viewToAdd.render();
            }
          },

          duplicateItemButtonClickedEventHandler: function() {
            var collectionItemView = genericCollectionItem.View;
            var elementToAdd = this.model.duplicateSelectedItem();
            if (elementToAdd) {
              var viewToAdd = new collectionItemView({
                model: elementToAdd
              });
              //this.insertView(".elements", viewToAdd);
              this.model.sortItems();
              this.$el.find(".alert").remove();
              viewToAdd.render();
            }
          },

          removeItemButtonClickedEventHandler: function() {
            var elementToRemove = this.model.removeSelectedItem();
            var viewToRemove = this.getView(function(view) {
              return (elementToRemove === view.model);
            });
            if (viewToRemove) {
              viewToRemove.$el.remove();
              this.model.sortItems();
            }
          },

          beforeRender: function() {
            var collection = this.model.get("collection"),
              collectionLength = collection ? collection.length : 0,
              collectionItemView = genericCollectionItem.View,
              i = 0;

            if (collection && collection.models)
              for (i = 0; i < collectionLength; i++)
                this.insertView(".elements", new collectionItemView({
                  model: collection.models[i]
                }));
          },

          afterRender: function() {
            var accessoryLineId = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"),
              systems = BticinoS4B.Instances.Models.ApplicationModel.get("choosenSystems"),
              systemsLength = systems.length,
              loadsControlEnabled = false,
              i = 0;

            for (i = 0; i < systemsLength; i++)
              if (systems[i] === "loadsControl") {
                loadsControlEnabled = true;
                break;
              }

            if (!loadsControlEnabled)
              this.$el.html("<h4 class='alert'>" + $.i18n._("IDS_W1_9102") + "</h4>");
            else {
              if (accessoryLineId && (!this.model.get("packagesFetched"))) {
                this.showLoader();
                this.model.fetchPackages();
              }
              window.customizeFormElements.call();
            }
          }

        })
      },

      Model: genericCollectionSection.Model.extend({
        defaults: _.extend({
          name: "IDS_WAM8_27",
          collectionEventAggregator: _.extend({}, Backbone.Events)
        }, genericCollectionSection.Model.prototype.defaults),

        initialize: function() {
          genericCollectionSection.Model.prototype.initialize.apply(this);
          var that = this;

          window.BticinoS4B.eventAggregator.bind("load:Project", this.loadProject, this);

          if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId") && BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId") !== 0)
            this.fetchPackages();
          else
            window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen", this.fetchPackages, this);

          this.set("maxItem", 63);
          this.get("collectionEventAggregator").unbind("selectedItem:changed", this.selectedItemChangedEventHandler);
          this.get("collectionEventAggregator").bind("selectedItem:changed", this.selectedItemChangedEventHandler, this);

          this.get("collectionEventAggregator").unbind("priorityChanged", this.priorityChangedEventHandler);
          this.get("collectionEventAggregator").bind("priorityChanged", this.priorityChangedEventHandler, this);

          window.BticinoS4B.eventAggregator.bind("modelDeliver:request", this.deliverModel, this);
          window.BticinoS4B.eventAggregator.bind("systems:changed", this.systemsChangedEventHandler, this);
          window.BticinoS4B.eventAggregator.bind("currentDeliver:requested", this.deliverCurrent, this);

          window.BticinoS4B.eventAggregator.unbind("controlledLoads:addedFromKit", this.productAddedFromKitEventHandler);
          window.BticinoS4B.eventAggregator.bind("controlledLoads:addedFromKit", this.productAddedFromKitEventHandler, this);
        },

        productAddedFromKitEventHandler: function(addedCommand) {
          var that = this;

          var addKitItems = function() {
            for (var j = addedCommand.quantity - 1; j >= 0; j--)
              that.addItem({
                packageClassId: addedCommand.packageClassId,
                generatedId: addedCommand.generatedId,
                partOfKit: true,
                kitsEventAggregator: addedCommand.kitsEventAggregator
              });

            that.trigger("render:requested");
            that.unbind("change:fetchingPackages", addKitItems);
          };

          if (this.get("fetchingPackages"))
            this.bind("change:fetchingPackages", addKitItems, this);
          else
            addKitItems();

        },

        deliverModel: function() {
          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.controlledLoads = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.controlledLoads = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.controlledLoads = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.controlledLoads = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.controlledLoads = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.controlledLoads = this;
              break;
          };
          BticinoS4B.Instances.Models.ApplicationModel.set("controlledLoads", this);
          var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
            collection = this.get("collection"),
            collectionLength = collection.models ? collection.models.length : 0,
            toReturn = [],
            i = 0,
            j = 0;

          for (i = 0; i < collectionLength; i++) {
            toReturn.push({
              productCode: collection.models[i].get("productCode"),
              productLabel: collection.models[i].get("productLabel"),
              packageClassLabel: collection.models[i].get("packageClassLabel"),
              packageClassId: collection.models[i].get("packageClassId"),
              kitValue: collection.models[i].get("kitValue"),
              partOfKit: collection.models[i].get("partOfKit"),
              loadType: "CC",
              slotsnumber: 1,
              quantity: 1,
              price: collection.models[i].get("price")
            });

            if (collection.models[i].get("secondaryProducts")) {
              for (j = collection.models[i].get("secondaryProducts").length - 1; j >= 0; j--) {
                toReturn.push({
                  productCode: collection.models[i].get("secondaryProducts")[j].productCode,
                  productLabel: collection.models[i].get("secondaryProducts")[j].productLabel,
                  packageClassId: collection.models[i].get("secondaryProducts")[j].packageClassId,
                  packageClassLabel: collection.models[i].get("secondaryProducts")[j].packageClassLabel,
                  kitValue: collection.models[i].get("kitValue"),
                  partOfKit: collection.models[i].get("partOfKit"),
                  quantity: 1,
                  price: collection.models[i].get("secondaryProducts")[j].price
                });
              }
            }

            if (this.get("accessory")) {
              toReturn.push({
                productCode: collection.models[i].get("accessory").productCode,
                productLabel: collection.models[i].get("accessory").productLabel,
                packageClassId: collection.models[i].get("accessory").packageClassId,
                packageClassLabel: collection.models[i].get("accessory").packageClassLabel,
                kitValue: collection.models[i].get("accessory").kitValue,
                partOfKit: collection.models[i].get("accessory").partOfKit,
                quantity: 1,
                price: collection.models[i].get("accessory").price
              });
            }
          }

          return toReturn;
        },

        resetCollection: function() {
          this.get("collection").reset();
          this.updateGlobalLengths();
        },

        systemsChangedEventHandler: function() {
          var systems = BticinoS4B.Instances.Models.ApplicationModel.get("choosenSystems"),
            systemsLength = systems.length,
            i = 0;

          if (systemsLength > 0)
            for (i = 0; i < systemsLength; i++) {
              if (systems[i] === "loadsControl")
                break;
              else
              if (i === (systemsLength - 1))
                this.resetCollection();
            } else
            this.resetCollection();

          this.trigger("render:requested");
          this.trigger("updateViews");
        },

        priorityChangedEventHandler: function(values) {
          var i = 0,
            models = this.get("collection").models,
            modelsLength = models.length;

          for (i = 0; i < modelsLength; i++)
            if (values.number !== models[i].get("number"))
              if (models[i].get("priorityValue") === values.newValue)
                models[i].set("priorityValue", values.oldValue);

          this.trigger("render:requested");
        },

        addPackageDetails: function() {
          var fetchedPackages = this.get("fetchedPackages"),
            selectedPackageClassId = this.get("packageClassId"),
            selectedPackages = _.filter(fetchedPackages, function(iterablePackage) {
              return iterablePackage.packageClassId === selectedPackageClassId;
            }),
            selectedPackage = selectedPackages.length > 0 ? selectedPackages[0] : undefined;

          if (selectedPackage)
            _.extend(this.attributes, selectedPackage);
        },

        addAccessoryDetails: function() {
          var fetchedAccessories = this.get("fetchedAccessories"),
            selectedPackageClassId = this.get("accessory") ? this.get("accessory").packageClassId : undefined,
            selectedPackages = _.filter(fetchedAccessories, function(iterablePackage) {
              return iterablePackage.packageClassId === selectedPackageClassId;
            }),
            selectedPackage = {
              accessory: selectedPackages.length > 0 ? selectedPackages[0] : undefined
            };

          if (selectedPackage)
            _.extend(this.attributes, selectedPackage);
          this.trigger("render:requested");
        },

        fetchPackages: function() {
          this.trigger("packages:fetching");
          if (!this.get("fetchingPackages")) {
            this.set("fetchingPackages", true);
            var that = this,
              //Defining race conditions variables
              controlledLoadsDataFetchCompleted = false,
              i = 0;

            //Race condition check
            var checkRaceCondition = function() {
              if (controlledLoadsDataFetchCompleted) {
                that.set("packagesFetched", true);
                that.trigger("packages:fetched");
              }
            };

            //Data products retrieval
            var retrieveProductData = function(data, confirmCondition) {
              var fetchedPackages = data.packages,
                fetchedPackagesLength = fetchedPackages.length,
                i = 0;

              var getProducts = function(originalPackage, confirmCondition) {
                BticinoS4B.Instances.Models.ApplicationModel.getProducts(originalPackage.packageClassId, function(data) {
                  var mainProduct = _.filter(data.products, function(product) {
                    return (product.mnemonic === 1);
                  })[0];
                  var secondaryProducts = _.filter(data.products, function(product) {
                    return (product.mnemonic !== 1);
                  });

                  _.extend(originalPackage, mainProduct);
                  originalPackage.secondaryProducts = secondaryProducts;

                  if (confirmCondition)
                    confirmCondition();

                  checkRaceCondition();
                });
              };

              for (i = 0; i < fetchedPackagesLength; i++) {
                if (fetchedPackages[i].specialVars && fetchedPackages[i].specialVars !== "" && typeof(fetchedPackages[i].specialVars) !== "object")
                  fetchedPackages[i].specialVars = JSON.parse(fetchedPackages[i].specialVars);

                if (i !== (fetchedPackagesLength - 1))
                  getProducts(fetchedPackages[i]);
                else
                  getProducts(fetchedPackages[i], confirmCondition);
              }

              return fetchedPackages;
            };

            //Defining success callbacks
            var controlledLoadsPackageFetchSuccessCallback = function(data) {
              that.attributes.fetchedPackages = retrieveProductData(data, function() {
                controlledLoadsDataFetchCompleted = true;
              });
              that.set("fetchingPackages", false);
            };

            BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(837, controlledLoadsPackageFetchSuccessCallback, undefined);
          }
        },

        getAvailablePriority: function() {
          var maxPriority = 0,
            models = this.get("collection").models,
            modelsLength = models.length,
            i = 0;

          for (i = 0; i < modelsLength; i++) {
            if (models[i].get("priorityValue") >= maxPriority)
              maxPriority = models[i].get("priorityValue") + 1;
          }

          return maxPriority;
        },

        updateGlobalLengths: function() {
          var collection = this.get("collection"),
            collectionLength = collection ? collection.length : 0;

          BticinoS4B.Instances.Models.ApplicationModel.set("controlledLoadsLength", collectionLength);
        },

        addItem: function(itemModel) {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          var defaultItem;

          var collectionItemModel = genericCollectionItem.Model;

          if (itemModel)
            defaultItem = new collectionItemModel(_.extend(itemModel, {
              fetchedPackages: this.get("fetchedPackages"),
              fetchedAccessories: this.get("fetchedAccessories"),
              collectionEventAggregator: this.get("collectionEventAggregator")
            }));
          else
            defaultItem = new collectionItemModel({
              fetchedPackages: this.get("fetchedPackages"),
              fetchedAccessories: this.get("fetchedAccessories"),
              number: this.getNewNumber(),
              collectionEventAggregator: this.get("collectionEventAggregator"),
              priorityValue: this.getAvailablePriority()
            });

          var itemsToAdd = [];
          itemsToAdd.push(defaultItem);
          if (genericCollectionSection.Model.prototype.addItem.apply(this, itemsToAdd)) {
            defaultItem.set("selected", true);
            this.trigger("updateViews", this.get("collection").length);

            this.updateGlobalLengths();
            //Trigger event for zone validation
            this.trigger("item:added");

            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
            this.sortItems();
            return defaultItem;
          }
        },

        duplicateItem: function(modelToDuplicate) {
          var collectionItemModel = genericCollectionItem.Model;
          var itemNumber = this.getNewNumber();
          var collection = this.get("collection"),
            collectionLength = collection.length;

          if (modelToDuplicate && collection.length + 1 <= this.get("maxItem")) {
            modelToDuplicate = new collectionItemModel(modelToDuplicate.attributes);

            modelToDuplicate.set("number", itemNumber);
            modelToDuplicate.set("priorityValue", this.getAvailablePriority());

            this.get("collection").add(modelToDuplicate);
            this.trigger("updateViews", this.get("collection").length);

            this.updateGlobalLengths();

            //Trigger event for zone validation
            this.trigger("item:added");

            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
            this.sortItems();
            return modelToDuplicate;
          } else {
            alert($.i18n._('IDS_W1_9128'));
            return false;
          }
        },

        removeItem: function(modelToRemove, _silent) {
          var silent = false;

          if (_silent)
            silent = _silent;

          if (!modelToRemove.get("partOfKit") || silent) {
            if (this.deleteItem(modelToRemove, silent)) {
              this.trigger("updateViews", this.get("collection").length);

              this.sortItems();

              //Trigger event for zone validation
              this.trigger("item:removed");
              this.trigger("render:requested");

              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");

              return modelToRemove;
            }
          } else{
            alert($.i18n._('IDS_W1_9191'));
            return false;
          }
        },

        sortItems: function() {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          var startNumber = this.get("startNumber"),
            i = 0;

          for (i = 0; i < collectionLength; i++) {
            collection.models[i].set("number", (startNumber + i));
            if (i === (collectionLength - 1))
              collection.models[i].set("selected", true);
            else
              collection.models[i].set("selected", false);
          }
        },

        deliverCurrent: function() {
          var collection = this.get("collection"),
            collectionLength = collection.models ? collection.models.length : 0;
          var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
          var extraConsumption = 30; //30 mA of extra consumption
          var mustDeliverExtraConsumption = false;
          var i = 0;

          //Delivering regular consumptions
          for (i = 0; i < collectionLength; i++)
            collection.models[i].deliverCurrent();
        },

        loadProject: function(project) {
          var that = this,
            oldCollection,
            i = 0,
            load = function() {
              if (that.get("collection")) {
                oldCollection = that.get("collection");
                if (oldCollection.models) oldCollection = oldCollection.models;
              }

              that.set("collection", new collectionModel());
              collection = that.get("collection");

              if (oldCollection) {
                for (i = 0; i < oldCollection.length; i++) {
                  if (!oldCollection[i].attributes)
                    that.addItem(_.extend({
                      collectionEventAggregator: that.get("collectionEventAggregator")
                    }, oldCollection[i]));
                  else
                    collection.add(new collectionItemModel($.extend({}, oldCollection[i].attributes)));
                }
                that.set("collection", collection);
                that.get("collectionEventAggregator").trigger("updateGlobalLengths");
                that.trigger("updateViews");
                window.BticinoS4B.eventAggregator.trigger("modelDeliver:request");
              }
            };

          if (project.energyManagement && project.energyManagement.controlledLoadsModel)
            this.set("collection", project.energyManagement.controlledLoadsModel.collection);

          if (!this.get("fetchedPackages"))
            this.bind("packages:fetched", load);
          else
            load();
        }
      }),
      genericCollectionItem: genericCollectionItem
    });

    // Required, return the module for AMD compliance
    return controlledLoad;

  });